import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { Rating } from '../../rating/rating.component';

export interface IRatingFormData {
  qualification: number;
  comment?: string;
}

export interface IRatingFormResult {
  qualification: number;
  comment: string;
}

@Component({
  selector: 'app-rating-form',
  imports: [FormsModule, MatDialogModule, Rating, TranslateModule],
  templateUrl: './rating-form.component.html',
  styleUrl: './rating-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatingForm {
  readonly dialogRef = inject(MatDialogRef<RatingForm>);
  readonly data = inject<IRatingFormData>(MAT_DIALOG_DATA);

  protected readonly qualification = signal<number>(this.data.qualification || 0);
  protected readonly comment = signal<string>(this.data.comment || '');
  protected readonly isEditing = computed(() => this.data.qualification > 0);

  protected setQualification(value: number): void {
    this.qualification.set(value);
  }

  protected setComment(value: string): void {
    this.comment.set(value);
  }

  protected submit(): void {
    const qualification = this.qualification();
    if (qualification < 1) return;

    this.dialogRef.close({
      qualification,
      comment: this.comment().trim(),
    } satisfies IRatingFormResult);
  }
}
